import { request } from 'src/commons/utils/async-request';
import { readCsrfToken } from './read-csrf-token';

const url = '/ccx/ajax/advertisingApiCsrf';

export default async (): Promise<string> => {
  try {
    const body = await request<string>({
      url,
      retries: 2,
      responseType: 'text',
    });
    return readCsrfToken(body) ?? '';
  } catch (e) {
    return '';
  }
};
